import styled from "@emotion/styled";

export const Label = styled.text`
  pointer-events: none;
  text-anchor: middle;
  font-weight: bold;
`;
